import { useMemo } from 'react'

import { useResolvedNodeDefinitions } from 'Automations/automationEditor/atoms'
import type { AutomationsPresentationV1Node } from 'Automations/automationEditor/types'
import { getNameForNode } from 'Automations/nodeDefinitions/helpers'

export type ReviewNodeOption = { label: string; value: string }

/**
 * Every quote review step in the workflow, named as the editor names it.
 *
 * All of them are offered, not just the ones downstream of the switch: a step
 * placed before it is a mistake worth naming rather than hiding, so validation
 * explains it must come after.
 */
export const useQuoteReviewNodes = (
  nodes: AutomationsPresentationV1Node[]
): ReviewNodeOption[] => {
  const definitions = useResolvedNodeDefinitions()

  return useMemo(
    () =>
      nodes.reduce<ReviewNodeOption[]>(
        (options, node) =>
          node.type === 'REVIEW_QUOTE'
            ? [
                ...options,
                { label: getNameForNode(node, definitions), value: node.id }
              ]
            : options,
        []
      ),
    [nodes, definitions]
  )
}
